module.exports = __webpack_public_path__ + "img/power.9fca9090.jpg";